import form from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';
import './Form';

form.init('form');
Zipcode.init();